import React from 'react'
import { useOrderById } from '../hooks/useOrderById'
import { routesDef } from '../../../../config/routes'
import { PaymentStatusContainer } from './PaymentStatusContainer'

export default function Success() {
  const { document, loading } = useOrderById()
  const orderName = `${document?.code ?? '--'} - ${document?.by?.company?.name ?? '--'}`
  const redirecTo = routesDef.OrderItemPage.altPath({ _id: document?._id })

  return (
    <PaymentStatusContainer
      orderName={orderName}
      redirecTo={redirecTo}
      loading={loading}
      message={'Payment Successful.'}
      subMessage={
        <ul>
          <li>
            <b>Card payments</b> are processed immediately.
          </li>

          <li>
            <b>Bank and ACH transfers</b> may take up to 5 business days to clear.
          </li>
          <li>
            The order payment status will be updated automatically once Stripe and the customer's bank confirm the
            transaction.
          </li>
        </ul>
      }
      icon="check"
      alertType="success"
    />
  )
}
